// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivilegeHeader_root__bHh5H","aspect":"PrivilegeHeader_aspect__2PWrA"};